import {
  createContext,
  Dispatch,
  FunctionComponent,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState
} from 'react';

export const AnnotationFormContext = createContext<{
  isAnnotationFormVisible: boolean;
  setAnnotationFormVisibility: Dispatch<SetStateAction<boolean>>;
}>({
  isAnnotationFormVisible: false,
  setAnnotationFormVisibility: () => {},
});

export const AnnotationFormContextProvider: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
  const [isAnnotationFormVisible, setAnnotationFormVisibility] = useState(false);

  return (
    <AnnotationFormContext.Provider value={{ isAnnotationFormVisible, setAnnotationFormVisibility }}>
      {children}
    </AnnotationFormContext.Provider>
  );
};

export const useAnnotationFormContext = () => useContext(AnnotationFormContext);

